import React from 'react';
import OrderSelect, { OrderSelectProps } from '../../../../../../Common/Select';

type BatteryType = 'Lithium Metal' | 'Lithium Ion' | 'Sodium Ion';

const packagingOptions: Record<BatteryType, { value: string; label: string }[]> = {
  'Lithium Metal': [
    { value: 'UN 3090 PI 968 IB', label: 'UN 3090 PI 968 IB' },
    { value: 'UN 3090 PI 968 IA', label: 'UN 3090 PI 968 IA' },
    { value: 'UN 3091 PI 969 Section I', label: 'UN 3091 PI 969 Section I' },
    { value: 'UN 3091 PI 970 Section I', label: 'UN 3091 PI 970 Section I' },
    { value: 'UN 3091 PI 969 & 970 Section II', label: 'UN 3091 PI 969 & 970 Section II' },
    { value: 'UN 3091 PI 970 Section II not restricted', label: 'UN 3091 PI 970 Section II not restricted' },
  ],
  'Lithium Ion': [
    { value: 'UN 3480 PI 965 IB', label: 'UN 3480 PI 965 IB' },
    { value: 'UN 3480 PI 965 IA', label: 'UN 3480 PI 965 IA' },
    { value: 'UN 3481 PI 966 Section I', label: 'UN 3481 PI 966 Section I' },
    { value: 'UN 3481 PI 967 Section I', label: 'UN 3481 PI 967 Section I' },
    { value: 'UN 3481 PI 966 & 967 Section II', label: 'UN 3481 PI 966 & 967 Section II' },
    { value: 'UN 3481 PI 967 Section II not restricted', label: 'UN 3481 PI 967 Section II not restricted' },
  ],
  'Sodium Ion': [
    { value: 'UN 3551 PI 976 Loose (bulk)', label: 'UN 3551 PI 976 Loose (bulk)' },
    { value: 'UN 3552 PI 977 Section I', label: 'UN 3552 PI 977 Section I' },
    { value: 'UN 3552 PI 978 Section I', label: 'UN 3552 PI 978 Section I' },
    { value: 'UN 3552 PI 977 & 978 Section II', label: 'UN 3552 PI 977 & 978 Section II' },
    { value: 'UN 3552 PI 978 Section II not restricted', label: 'UN 3552 PI 978 Section II not restricted' },
  ],
};

interface SelectBatteryPackagingProps extends OrderSelectProps {
  batteryType?: BatteryType;
}

function SelectBatteryPackaging({ batteryType, selectProps, ...props }: SelectBatteryPackagingProps) {
  const options = batteryType ? packagingOptions[batteryType] : [];

  return (
    <OrderSelect
      options={options}
      {...props}
      selectProps={{
        placeholder: 'Select battery packaging',
        disabled: !batteryType,
        ...(selectProps || {}),
      }}
    />
  );
}

export default SelectBatteryPackaging;
